import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-internet-error-state',
    templateUrl: './internet-error-state.component.html',
    styleUrls: ['./internet-error-state.component.scss'],
    imports: [MatIcon]
})
export class InternetErrorStateComponent {

}
